$(function(){ 
  function checkPassword(pass){
  	    var password = "glittertwine";
    	if(pass !== password) {
        	$("#Error").text("Sorry, incorrect password");
   		}
    	else {
          	$('#PasswordProtect').hide();
          	$("#Error").text('');
        	$('#Hidden').show();
   		}
  }
   $("#submitpass").click(function() {
		pass_value = $("#pass").val();
     	checkPassword(pass_value);
	});
  
  $(window).keydown(function(event){
    if(event.keyCode == 13) {
      pass_value = $("#pass").val();
      checkPassword(pass_value);
      event.preventDefault();
      return false;
    }
  });
});